import { Dialog } from '@headlessui/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { UserDetailInfo } from './types';

interface IUserDetailHeaderProps {
  user: UserDetailInfo;
}

export const UserDetailHeader: FunctionComponent<IUserDetailHeaderProps> = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='flex justify-end pb-16'></div>
      <div className='text-center'>
        <Dialog.Title className='my-4 text-lg font-semibold text-gray-900'>{user.email}</Dialog.Title>
        <p className='mb-2 text-sm text-gray-500'>{t('COMMON:role')}</p>
        <div className='flex justify-center gap-2'>
          <span className='rounded-md border border-gray-200 bg-gray-50 px-2 py-1 text-xs font-medium text-gray-700'>
            {user.role === 'readonly' ? t('COMMON:readonly') : t('COMMON:admin')}
          </span>
        </div>
      </div>
    </div>
  );
};
